import apiClient from "../utils/apiUtils";

export const interviewService = {
  // Search interviewers by query (supports comma-separated values)
  searchInterviewers: async (searchQuery) => {
    try {
      const response = await apiClient.get(`/interviewers/search?search=${encodeURIComponent(searchQuery)}`);
      return response.data;
    } catch (error) {
      console.error("Error searching interviewers:", error);
      throw error;
    }
  },
  
  // Submit interview feedback with decision, categories, weights, and rejection reason
  submitInterviewFeedback: async (feedbackData) => {
    try {
      const response = await apiClient.post("/interviews/feedback", feedbackData);
      return response.data;
    } catch (error) {
      console.error("Error submitting interview feedback:", error);
      throw error;
    }
  },
};

